/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Audit_Event_Data_Room_Accessed17Inputs */

const en_coinvestments_audit_event_data_room_accessed17 = /** @type {(inputs: Coinvestments_Audit_Event_Data_Room_Accessed17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Room Accessed`)
};

/**
* | output |
* | --- |
* | "Data Room Accessed" |
*
* @param {Coinvestments_Audit_Event_Data_Room_Accessed17Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_audit_event_data_room_accessed17 = /** @type {((inputs?: Coinvestments_Audit_Event_Data_Room_Accessed17Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Audit_Event_Data_Room_Accessed17Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_audit_event_data_room_accessed17(inputs)
});
export { coinvestments_audit_event_data_room_accessed17 as "coInvestments_audit_event_DATA_ROOM_ACCESSED" }